import {
  FontOption,
  PulsatingCircleWidgetProps,
} from '@pulsoid-private/widgets-lib';
import React from 'react';
import {Col, Form, Row} from 'react-bootstrap';
import Ranges from '../../../system/ranges';
import ColorPicker from './ColorPicker';
import merge from 'lodash/merge';
import {Action} from '../../../system/buttons';
import {PremiumWrapperOverlay} from '../../PremiumWrapperOverlay';
import {BasicFormElement} from '../../../system/form';
import {NewFontManager} from '../../../system/NewFontManager/NewFontManager';

export const PulsatingCircleWidgetEdit = (props) => {
  const [configuration, setConfiguration] = React.useState<
    PulsatingCircleWidgetProps['configuration']
  >(merge(props.configuration));

  const updateConfiguration = (
    configPart: Partial<PulsatingCircleWidgetProps['configuration']>
  ) => {
    const newConfiguration = {...configuration, ...configPart};
    setConfiguration(newConfiguration);
    props.onUpdate(newConfiguration);
  };

  const handleOnSave = () => {
    props.onSave(configuration);
  };

  return (
    <>
      <PremiumWrapperOverlay
        bi={{
          from: 'widget_edit_premium_update',
          id: props.id,
        }}
        disabled={!props.premiumUpdate}
      >
        <BasicFormElement label={'Should sync shape and text color'}>
          <Form.Check
            type="checkbox"
            checked={configuration.shouldSyncColors}
            onChange={(e) => {
              updateConfiguration({
                shouldSyncColors: (e.target as unknown as {checked: boolean})
                  .checked,
              });
            }}
          />
        </BasicFormElement>
        {!configuration.shouldSyncColors && (
          <BasicFormElement label={'Text color'}>
            <ColorPicker
              color={configuration.textStyles?.color ?? '#000000'}
              onChangeComplete={(color) => {
                updateConfiguration({
                  textStyles: {...configuration.textStyles, color},
                });
              }}
            />
          </BasicFormElement>
        )}
        <NewFontManager
          withUpload={true}
          font={configuration.textStyles?.font ?? 'Inter'}
          onChange={(font) => {
            let casted = font as unknown as FontOption;
            updateConfiguration({
              textStyles: {...configuration.textStyles, font: casted},
            });
          }}
        ></NewFontManager>
        <BasicFormElement label={'Additional text'}>
          <Form.Control
            value={configuration.additionalText?.value}
            onChange={(e) =>
              updateConfiguration({
                additionalText: {value: e.target.value},
              })
            }
          />
        </BasicFormElement>
        <Form.Group>
          <Ranges
            ranges={configuration.ranges}
            defaultRange={{
              from: 40,
              to: 250,
              shapeColor: '#ffffff',
            }}
            onRangesChange={(ranges) => updateConfiguration({ranges})}
            header={
              <Col md={3}>
                <Form inline>
                  <Col>Color</Col>
                </Form>
              </Col>
            }
            rangeConfiguration={(range, onRangeChange) => (
              <Col md={3} key={range.from}>
                <Row>
                  <Col>
                    <Form inline>
                      <ColorPicker
                        color={range.shapeColor}
                        onChangeComplete={(shapeColor) =>
                          onRangeChange({...range, shapeColor})
                        }
                      />
                    </Form>
                  </Col>
                </Row>
              </Col>
            )}
          />
        </Form.Group>
        <Action onClick={handleOnSave}>Save settings</Action>
      </PremiumWrapperOverlay>
    </>
  );
};
